import React, { useEffect } from 'react';
import styles from './agendamento_isabellacoimbra_sobrancelhas.module.scss';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import perfilAgendamento from './src/perfil-agendamento.png';

const WHATSAPP_NUMBER = '5517988130264';

const HORARIOS = [
    { dia: 'Seg', horario: '10:00 - 16:30' },
    { dia: 'Ter', horario: '10:00 - 16:30' },
    { dia: 'Qua', horario: '10:00 - 16:30' },
    { dia: 'Qui', horario: '10:00 - 16:30' },
    { dia: 'Sex', horario: '10:00 - 19:00' },
    { dia: 'Sáb', horario: '09:00 - 13:30' },
];

const Agendamento_isabellacoimbra_sobrancelhas: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const openWhatsApp = () => {
        const msg = encodeURIComponent(
            'Olá, vim pelo cartão digital e gostaria de agendar um horário...'
        );
        window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${msg}`, '_blank');
    };

    return (
        <div className={styles.pageWrapper}>
            <div className={styles.agendamento_isabellacoimbra_sobrancelhas}>
                <div className={styles.header}>
                    <Link to="/isabellacoimbra_sobrancelhas" className={styles.backButton} aria-label="Voltar">
                        <FaArrowLeft />
                    </Link>
                    <h2>Agendamento</h2>
                </div>

                <div className={styles.profile}>
                    <h1 className={styles.nome}>Isabella Coimbra</h1>
                    <img
                        src={perfilAgendamento}
                        alt="Isabella Coimbra"
                        className={styles.foto}
                    />
                    <p className={styles.texto}>Faça seu agendamento</p>
                    <p className={styles.subtitulo}>
                        Reserve seu horário e tenha um atendimento personalizado, pensado para realçar a sua beleza natural.
                    </p>
                    <button type="button" className={styles.ctaButton} onClick={openWhatsApp}>
                        Quero agendar
                    </button>
                </div>

                <div className={styles.horariosCard}>
                    <h3 className={styles.horariosTitle}>Horário de Atendimento</h3>
                    <ul className={styles.horariosList}>
                        {HORARIOS.map((item) => (
                            <li key={item.dia}>
                                <span className={styles.dia}>{item.dia}</span>
                                <span className={styles.horario}>{item.horario}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Agendamento_isabellacoimbra_sobrancelhas;
